import { createContext, useContext, type ReactNode } from 'react';

type ClientOverride = { clientFullName?: string } | null;

const ClientOverrideContext = createContext<ClientOverride>(null);

export function useClientOverride() {
  return useContext(ClientOverrideContext);
}

export function ClientOverrideProvider({
  children,
  client,
}: {
  children: ReactNode;
  client: ClientOverride;
}) {
  return <ClientOverrideContext.Provider value={client}>{children}</ClientOverrideContext.Provider>;
}
